import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-icon',
  template: `
    <ion-icon 
      name="information-circle-outline" 
      [title]="getHelpText()"
      style="cursor: pointer;"
      [class]="cssClass">
    </ion-icon>
  `
})
export class HelpIconComponent {
  @Input() helpKey: string = '';
  @Input() translationObject: any = {};
  @Input() cssClass: string = '';

  getHelpText(): string {
    if (!this.helpKey || !this.translationObject) {
      return this.translationObject?.['Hilfe'] || 'Help';
    }

    // First try the key directly (for keys like "UploadLogoInterview")
    if (this.translationObject[this.helpKey]) {
      return this.translationObject[this.helpKey];
    }

    // Then try with "Help" prefix and capitalized first letter (for keys like "HelpJobOfferLanguage")
    const helpKey = `Help${this.helpKey.charAt(0).toUpperCase() + this.helpKey.slice(1)}`;
    return this.translationObject[helpKey] || this.translationObject['HilfeNichtVerfügbar'] || 'Hilfe für diesen Bereich ist nicht verfügbar.';
  }
}
